<template>
  <a @click="disconnect">
    Déconnexion
  </a>
</template>

<script>
import { mapActions } from "vuex";
import { Toast } from "buefy/src/components/toast";

export default {
  methods: {
    ...mapActions("auth", ["logOut"]),
    disconnect() {
      Toast.open({
        message: "<i class='fas fa-lock'></i> Vous allez être déconnecté !",
        type: "is-primary"
      });
      setTimeout(() => this.$router.push({ name: "Login" }), 1000);
      this.logOut();
    }
  }
};
</script>
